import { useState, useEffect } from 'react';
import { supabase, TABLES } from '../utils/supabase';
import type { TokenData } from '../types';

export interface PoolWithTVL extends TokenData {
  tvl?: number; // Total Value Locked (can be calculated or stored)
  pool_exists?: boolean;
}

export const useMavrkPools = () => {
  const [pools, setPools] = useState<PoolWithTVL[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPools = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('🔍 [useMavrkPools] Fetching Mavrk pools from Supabase...');

      // Query tokens table for Ink network tokens that have pool addresses
      const { data, error: fetchError } = await supabase
        .from(TABLES.TOKENS)
        .select('*')
        .eq('network', 'ink')
        .not('pool_address', 'is', null) // Only tokens with pools
        .order('created_at', { ascending: false });

      if (fetchError) {
        throw new Error(fetchError.message);
      }

      console.log('✅ [useMavrkPools] Fetched pools:', {
        count: data?.length || 0,
        sample: data?.slice(0, 3).map(t => ({
          name: t.name,
          symbol: t.symbol,
          pool: t.pool_address,
          nft: t.nft_token_id
        }))
      });

      // Transform to include TVL (if available in future)
      const poolsWithTVL: PoolWithTVL[] = (data || []).map(token => ({
        ...token,
        pool_exists: !!token.pool_address,
        // TVL can be added here if you have it in the database or calculate it
        // tvl: token.tvl || 0
      }));

      setPools(poolsWithTVL);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch pools';
      console.error('❌ [useMavrkPools] Error:', errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPools();
  }, []);

  return {
    pools,
    loading,
    error,
    refetch: fetchPools
  };
};

